import LandingSection from 'components/landing/components/landing-section';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
// import moneyIcon from 'static/img/icons/landing_money.svg';
// import lupeIcon from 'static/img/icons/landing_lupe.svg';
// import mouseIcon from 'static/img/icons/landing_mouse.svg';
import useRichTranslation from 'hooks/useRichTranslation';

const FindBestPrice = () => {
    const t = useRichTranslation('find-best-price');
    const { seoText, verification } = useGetSeoTextByIndex('find_best_price');

    if (!verification) {
        // TODO: Add sentry custom error
        return null;
    }

    return (
        <LandingSection>
            <Title content={t('title')} />
            <div className="paragraph_wrapper_short">
                <TextBox
                    title={t('columns.1.title')}
                    content={t('columns.1.description')}
                    align
                />
                <TextBox
                    title={t('columns.2.title')}
                    content={t('columns.2.description')}
                    align
                />
                <TextBox
                    title={t('columns.3.title')}
                    content={t('columns.3.description')}
                    align
                />
            </div>
            <Text
                content={`${seoText.paragraph1.sentence1} ${seoText.paragraph1.sentence2} ${seoText.paragraph1.sentence3}`}
                width="auto"
                marginBottom="40px"
            />
        </LandingSection>
    );
};

export default FindBestPrice;
